import React, { useMemo } from 'react';
import { Box, Button, Grid, IconButton, LinearProgress, Typography, useMediaQuery } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import ExcludeEntrevistaButton from '../../entrevista/components/ExcludeEntrevistaButton';
import { usePacienteEntrevistas } from '../hooks/usePacienteEntrevistas';
import { isAdminSession } from '../../../shared/auth/session';

export default function PacienteEntrevistasTable({ idPaciente }) {
  const { entrevistas, loading, fetchEntrevistas } = usePacienteEntrevistas({ idPaciente });
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isAdmin = useMemo(() => isAdminSession(), []);

  const columns = useMemo(() => {
    const baseColumns = [
      { field: 'fecha', headerName: 'Fecha', width: 150 },
      { field: 'tipo', headerName: 'Tipo', width: 120 },
      { field: 'venredi', headerName: 'VENREDI', width: 150 },
      { field: 'terapiaOcupacional', headerName: 'Terapia Ocupacional', width: 180, flex: 1 },
      {
        field: 'actions',
        headerName: '',
        width: 80,
        sortable: false,
        filterable: false,
        renderCell: (params) => (
          <IconButton onClick={() => navigate(`/ver-entrevista/${params.row.id}/${idPaciente}`)}>
            <VisibilityIcon />
          </IconButton>
        ),
      },
    ];

    if (isAdmin) {
      baseColumns.push({
        field: 'delete',
        headerName: '',
        width: 90,
        sortable: false,
        filterable: false,
        renderCell: (params) => (
          <ExcludeEntrevistaButton entrevistaId={params.row.id} onDeleted={fetchEntrevistas} />
        ),
      });
    }

    return baseColumns;
  }, [fetchEntrevistas, idPaciente, isAdmin, navigate]);

  return (
    <>
      <Typography variant={isMobile ? 'h5' : 'h6'} gutterBottom color="#0D6AEE" sx={{ px: { xs: 0.5, sm: 0 } }}>
        Lista de Entrevistas
      </Typography>
      <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Grid item>
          <Button variant="contained" startIcon={<RestartAltIcon />} onClick={fetchEntrevistas} sx={{ borderRadius: 2, width: { xs: '100%', sm: 'auto' } }}>
            Refrescar
          </Button>
        </Grid>
      </Grid>
      {loading ? (
        <LinearProgress />
      ) : (
        <Box sx={{ height: isMobile ? 360 : 400, width: '100%' }}>
          <DataGrid
            rows={entrevistas}
            columns={columns}
            initialState={{ pagination: { paginationModel: { pageSize: isMobile ? 5 : 10, page: 0 } } }}
            pageSizeOptions={[5, 10, 25, 50]}
            slots={isMobile ? undefined : { toolbar: GridToolbar }}
            disableRowSelectionOnClick
            disableColumnFilter={isMobile}
            disableColumnSelector={isMobile}
            disableDensitySelector={isMobile}
          />
        </Box>
      )}
    </>
  );
}
